import {
  Root as ContextMenuRoot,
  Portal as ContextMenuPortal,
} from "@radix-ui/react-context-menu";
import { ContextMenuContent } from "./ContextMenuContent";
import { ContextMenuProps } from "./types";
import { ContextMenuTrigger } from "./ContextMenuTrigger";

export const ContextMenu = <TData,>({
  contextMenuItems,
  data,
  children,
  isDisabled,
  usePortal = true,
  className,
  modal = false,
  shouldOpenContextMenuByLeftClick = false,
}: ContextMenuProps<TData>) => {
  if (usePortal) {
    return (
      <ContextMenuRoot modal={modal}>
        <ContextMenuTrigger
          shouldOpenContextMenuByLeftClick={shouldOpenContextMenuByLeftClick}
          isDisabled={isDisabled}
          className={className}
        >
          {children}
        </ContextMenuTrigger>
        <ContextMenuPortal>
          <ContextMenuContent contextMenuItems={contextMenuItems} data={data} />
        </ContextMenuPortal>
      </ContextMenuRoot>
    );
  }

  return (
    <ContextMenuRoot modal={modal}>
      <ContextMenuTrigger
        shouldOpenContextMenuByLeftClick={shouldOpenContextMenuByLeftClick}
        isDisabled={isDisabled}
        className={className}
      >
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent contextMenuItems={contextMenuItems} data={data} />
    </ContextMenuRoot>
  );
};

export type { ContextMenuItems, ContextMenuProps } from "./types";
export { ContextMenuVariant } from "./types";
